import React, { FC, useState } from 'react';
import { RichText } from '@sitecore-jss/sitecore-jss-react';
import useMediaQuery from '../../../lib/custom-hooks/useMediaQuery';
import { TMediaAssetType } from '../types/splitModule.types';
import { BreakpointsInPx } from '../../../constants/breakpoints.constants';
import VideoPlayer from '../../@shared/videoPlayer';
import Picture from '../../@shared/picture';
import { getThumbnailProps } from '../../../utils/youtubeUtils';
import { getImageField } from '../../../utils/getImageFields';
import { TEditorialImageProps } from '../../@shared/picture/types/editorialImage.types';
import MediaCarousel from '../../@shared/mediaCarousel';

const MediaAsset: FC<TMediaAssetType> = (props) => {
  const isWide = useMediaQuery(`(min-width: ${BreakpointsInPx.md})`);
  const [videoPlaying, setVideoPlaying] = useState(false);

  const playCallback = (): void => {
    setVideoPlaying(true);
  };

  const endCallback = (): void => {
    setVideoPlaying(false);
  };

  const { thumbnailImgSrc } = getThumbnailProps(props?.video?.value?.href || '');
  const desktopImage = getImageField(props.image, thumbnailImgSrc || '', props.useVideo);
  const mobileImage = getImageField(props.mobileImage, thumbnailImgSrc || '', props.useVideo);

  const editorialImageProps: TEditorialImageProps = {
    id: props.id,
    desktopImage: props.useVideo ? desktopImage : props.image,
    mobileImage: props.useVideo ? mobileImage : props.mobileImage,
    desktopTransformation: 'Size1000',
    mobileTransformation: 'Size500',
    cssClassImageEl: 'split-module__image',
    cssClassPictureEl: 'split-module__fixed-aspect-ratio',
  };

  if (props.carouselSlide.length > 0) {
    return (
      <MediaCarousel
        slides={props.slides}
        extraClassName="split-module__media-carousel"
        mediaHeightClassName="split-module__media-height"
      />
    );
  }

  if (props.useVideo) {
    return (
      <div className="split-module__fixed-aspect-ratio">
        <VideoPlayer
          link={props.video?.value?.href?.replace('sitecore/media-library', '-/media')}
          autoPlay={!props.isEE}
          showThumbnail={true}
          muted={isWide}
          playCallback={playCallback}
          endCallback={endCallback}
          extraClassName={'split-module__video-wrapper'}
          editorialImageProps={editorialImageProps}
        />
        {isWide && !videoPlaying && (
          <div className="split-module__video-text-wrapper">
            {props.videoHeading && <RichText tag="div" className="split-module__video-title rich-text" field={props.videoHeading} />}
            {props.videoSubHeading && (
              <RichText tag="div" className="split-module__video-subtitle rich-text" field={props.videoSubHeading} />
            )}
          </div>
        )}
      </div>
    );
  } else {
    return <Picture editorialImageProps={editorialImageProps} />;
  }
};

export default MediaAsset;
